var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#0CAF6D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 23.5711H25.2856C25.5887 23.5711 25.8794 23.4507 26.0937 23.2364C26.308 23.0221 26.4284 22.7314 26.4284 22.4283V17.2854C26.4284 16.9823 26.308 16.6916 26.0937 16.4773C25.8794 16.263 25.5887 16.1426 25.2856 16.1426H12.7141C12.411 16.1426 12.1204 16.263 11.906 16.4773C11.6917 16.6916 11.5713 16.9823 11.5713 17.2854V22.4283C11.5713 22.7314 11.6917 23.0221 11.906 23.2364C12.1204 23.4507 12.411 23.5711 12.7141 23.5711H14.9999",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.8574V25.8574C15 26.009 15.0602 26.1543 15.1674 26.2615C15.2745 26.3686 15.4199 26.4289 15.5714 26.4289H22.4286C22.5801 26.4289 22.7255 26.3686 22.8326 26.2615C22.9398 26.1543 23 26.009 23 25.8574V21.8574H15Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 16.1427V12.1427C23 11.9912 22.9398 11.8458 22.8326 11.7387C22.7255 11.6315 22.5801 11.5713 22.4286 11.5713H15.5714C15.4199 11.5713 15.2745 11.6315 15.1674 11.7387C15.0602 11.8458 15 11.9912 15 12.1427V16.1427",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5716 19H22.4287",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintSvg);
export default __webpack_public_path__ + "static/media/printSvg.1c0070325a70790f7e98d8864090efd4.svg";
export { ForwardRef as ReactComponent };